export default "__VITE_ASSET__DHT0lNJK__"